import React from 'react';

/** Live Moments add-on switch — used on the pricing page and in the paywall. */
export default function MomentsToggle({ checked, onChange, t }) {
  return (
    <label className="flex items-center gap-3 max-w-md w-full rounded-2xl border border-[#E2DCD7] dark:border-[#2a2a3a] bg-white dark:bg-[#1e1e2a] px-4 py-3 text-left cursor-pointer">
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-semibold text-[#1C1A22] dark:text-stone-100">{t('pricing.momentsToggleTitle')}</span>
        <span className="block text-xs text-[#6B6672] dark:text-stone-400 mt-0.5">{t('pricing.momentsToggleBody')}</span>
      </span>
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only peer"
        aria-label={t('pricing.momentsToggleTitle')}
      />
      <span
        aria-hidden="true"
        className="relative shrink-0 w-11 h-6 rounded-full bg-[#CFC7C1] dark:bg-stone-600 transition peer-checked:bg-[#9A4357] peer-focus-visible:ring-2 peer-focus-visible:ring-[#9A4357] after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:w-5 after:h-5 after:rounded-full after:bg-white after:transition peer-checked:after:translate-x-5"
      />
    </label>
  );
}
